webpackJsonp([178],{

/***/ 1302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAccountTable_vue__ = __webpack_require__(3065);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d5faf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAccountTable_vue__ = __webpack_require__(5701);
function injectStyle (ssrContext) {
  __webpack_require__(5694)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02d5faf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAccountTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d5faf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAccountTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 3065:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_user_bank_account_components_UserBankFormDialog__ = __webpack_require__(5696);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */]],
  components: {
    UserBankFormDialog: __WEBPACK_IMPORTED_MODULE_2__views_user_bank_account_components_UserBankFormDialog__["a" /* default */]
  },
  data: function data() {
    return {
      search: {
        user_id: null,
        name: null
      },
      searchFieldType: {
        user_id: Number
      },
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      dialogTitle: '',
      dialogVisible: false,
      dialogId: 0,
      exportHeader: [{
        key: 'id',
        text: 'ID'
      }, {
        key: 'user_name',
        text: '用户名'
      }, {
        key: 'department_name',
        text: '部门'
      }, {
        key: 'department_job_name',
        text: '岗位'
      }, {
        key: 'realname',
        text: '员工姓名'
      }, {
        key: 'first_approver_name',
        text: '一级审批人'
      }, {
        key: 'second_approver_name',
        text: '二级审批人'
      }, {
        key: 'third_approver_name',
        text: '三级审批人'
      }, {
        key: 'fourth_approver_name',
        text: '四级审批人'
      }, {
        key: 'name',
        text: '账户名称'
      }, {
        key: 'bank_account',
        text: '银行账号'
      }, {
        key: 'bank',
        text: '开户银行支行'
      }, {
        key: 'bank_headquarters',
        text: '开户银行总行'
      }]
    };
  },

  computed: Vuex.mapState({}),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getPlatformUsersDetail', 'getPlatformUsersIndex']), {

    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData: function getTableData(params) {
      return request.page('getUserBankAccountTable', params);
    },
    createUserBank: function createUserBank() {
      var _this = this;

      request.loading('createUserBankAccount', { 'is_test_permission': 1 }).then(function (_) {
        _this.dialogTitle = '添加员工账户';
        _this.dialogVisible = true;
        _this.dialogId = 0;
      }).catch(function (_) {
        _this.$message.error('抱歉，您没有权限执行此操作');
      });
    },
    batchCreateUserBank: function batchCreateUserBank() {
      var _this2 = this;

      request.loading('batchCreateUserBankAccount', { 'is_test_permission': 1 }).then(function (_) {
        _this2.$router.push('/user-bank-account/create/batch');
      }).catch(function (_) {
        _this2.$message.error('抱歉，您没有权限执行此操作');
      });
    },
    batchEditUserBank: function batchEditUserBank() {
      var _this3 = this;

      request.loading('batchEditUserBankAccount', { 'is_test_permission': 1 }).then(function (_) {
        _this3.$router.push('/user-bank-account/edit/batch');
      }).catch(function (_) {
        _this3.$message.error('抱歉，您没有权限执行此操作');
      });
    },
    editUserBank: function editUserBank(id) {
      var _this4 = this;

      request.loading('updateUserBankAccount', { id: id, 'is_test_permission': 1 }).then(function (_) {
        _this4.dialogTitle = '修改员工账户';
        _this4.dialogVisible = true;
        _this4.dialogId = id * 1;
      }).catch(function (_) {
        _this4.$message.error('抱歉，您没有权限执行此操作');
      });
    },
    onDelete: function onDelete(id) {
      var _this5 = this;

      // 测试有删除权限后，在进行删除
      var uri = 'delUserBankAccountById';
      request.loading(uri, { id: id, 'is_test_permission': 1 }).then(function (_) {
        _this5.$confirm('确定要删除吗？', '警告', { type: 'warning' }).then(function (_) {
          request.common(uri, { id: id }).then(function (_) {
            _this5.$message.success('删除成功');
            _this5.onSearch();
          });
        });
      }).catch(function (_) {
        _this5.$message.error('抱歉，您没有权限执行此操作');
      });
    },
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    },
    getExportData: function getExportData(params) {
      return request.page('getUserBankAccountTable', params);
    },
    onExportSearch: function onExportSearch() {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getExportData,
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          return data;
        }
      });
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.dialogId = 0;
    },
    closeDialogRefresh: function closeDialogRefresh() {
      this.closeDialog();
      this.$router.go(0);
    }
  })
});

/***/ }),

/***/ 3066:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_bank_account_rules_js__ = __webpack_require__(5699);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      formRules: __WEBPACK_IMPORTED_MODULE_3__user_bank_account_rules_js__["a" /* formRules */],
      form: {
        'user_id': null,
        'user_name': null,
        'department_id': null,
        'department_job_id': null,
        'name': null,
        'realname': null,
        'bank_account': null,
        'bank': null,
        'bank_headquarters': null,
        'first_approver': null,
        'second_approver': null,
        'third_approver': null,
        'fourth_approver': null
      },
      user_list: []
    };
  },

  props: {
    visible: Boolean,
    title: String,
    id: Number
  },
  watch: {
    id: {
      handler: function handler(val) {
        if (val > 0) {
          this.setForm(val);
        } else {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    user: function user(state) {
      return state.login.user;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getDepartmentJobLists', 'getDepartmentJobDetail']), Vuex.mapActions(['getPlatformUsersDetail', 'getPlatformUsersIndex']), {
    closeDialog: function closeDialog() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.$emit('closeDialog');
    },
    closeDialogRefresh: function closeDialogRefresh() {
      this.$emit('closeDialogRefresh');
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getUserBankAccountById', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          if (_this2.checkSubmit()) {
            _this2.id ? _this2.updateUserBank(_this2.id) : _this2.createUserBank();
          }
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    checkSubmit: function checkSubmit() {
      if (this.id * 1 === 0) {
        for (var i = 0; i < this.user_list.length; i++) {
          if (this.user_list[i].id * 1 === this.form.user_id * 1) {
            this.form.user_name = this.user_list[i].name;
            break;
          }
        }
      }
      if (!this.form.user_name) {
        this.$message.error('请选择用户名');
        return false;
      }
      return true;
    },
    createUserBank: function createUserBank() {
      var _this3 = this;

      request.common('createUserBankAccount', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getForm())).then(function (res) {
        _this3.$confirm('添加员工账户信息成功, 是否关闭弹层？', '提示', { type: 'success' }).then(function () {
          _this3.closeDialogRefresh();
        });
      });
    },
    updateUserBank: function updateUserBank(id) {
      var _this4 = this;

      request.common('updateUserBankAccount', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this4.$confirm('修改员工账户信息成功, 是否关闭弹层？', '提示', { type: 'success' }).then(function () {
          _this4.closeDialogRefresh();
        });
      });
    },
    getForm: function getForm() {
      return filter.copyJson(this.form);
    },
    getPlatformUsersList: function getPlatformUsersList(query) {
      var _this5 = this;

      return request.common('getPlatformUsersIndex', query).then(function (res) {
        _this5.user_list = res.data.data;
        return res;
      });
    },
    getCurrentUsersDetail: function getCurrentUsersDetail(id) {
      var _this6 = this;

      return request.common('getPlatformUsersDetail', id).then(function (res) {
        _this6.form.user_name = res.data.name;
        return res;
      });
    },
    chooseUser: function chooseUser(user) {
      var _this7 = this;

      request.common('getuserAccountDetailByUserID', { id: user.id }).then(function (_ref2) {
        var data = _ref2.data;

        var tempUser = data.pop();
        if (tempUser) {
          _this7.form.first_approver = tempUser.first_approver;
          _this7.form.second_approver = tempUser.second_approver;
          _this7.form.third_approver = tempUser.third_approver;
          _this7.form.fourth_approver = tempUser.fourth_approver;
          _this7.form.department_id = tempUser.department_id;
          _this7.form.department_job_id = tempUser.department_job_id;
          _this7.form.realname = tempUser.realname;
        }
      });
    },
    getFinCenterDepartmentList: function getFinCenterDepartmentList() {
      return request.common('getFinCenterDepartmentTableList', { per_page: 100, is_disabled: 0 });
    },
    getFinCenterDepartmentDetail: function getFinCenterDepartmentDetail() {
      return request.common('getFinCenterDepartmentDetail', { id: this.form.department_id });
    }
  })
});

/***/ }),

/***/ 5694:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5695);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a4563f96", content, true, {});

/***/ }),

/***/ 5695:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UserAccountTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBankFormDialog_vue__ = __webpack_require__(3066);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ce2f52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBankFormDialog_vue__ = __webpack_require__(5700);
function injectStyle (ssrContext) {
  __webpack_require__(5697)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44ce2f52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBankFormDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ce2f52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBankFormDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5697:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5698);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("70caf7e1", content, true, {});

/***/ }),

/***/ 5698:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".user-bank-form-dialog[data-v-44ce2f52] .el-dialog{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:0!important;position:absolute;top:50%;left:50%;width:600px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);max-height:calc(100% - 30px);max-width:calc(100% - 30px)}.user-bank-form-dialog[data-v-44ce2f52] .el-dialog .el-dialog__body{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow:auto}", "", {"version":3,"sources":["/workspace/src/views/user-bank-account/components/UserBankFormDialog.vue"],"names":[],"mappings":"AACA,mDACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,mBAAqB,AACrB,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,YAAa,AACb,uCAAyC,AACjC,+BAAiC,AAEzC,6BAA8B,AAC9B,2BAA6B,CAC9B,AACD,oEACE,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,aAAe,CAChB","file":"UserBankFormDialog.vue","sourcesContent":["\n.user-bank-form-dialog[data-v-44ce2f52] .el-dialog {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 0 !important;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 600px;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  /*height:600px;*/\n  max-height: calc(100% - 30px);\n  max-width: calc(100% - 30px);\n}\n.user-bank-form-dialog[data-v-44ce2f52] .el-dialog .el-dialog__body {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])())]
};

var formRules = {
  user_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择用户名', 'integer', 'blur', true), { min: 1 })],
  department_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择部门', 'integer', 'blur', true), { min: 1 })],
  department_job_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择岗位', 'integer', 'blur', true), { min: 1 })],
  realname: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入员工姓名'), { min: 1 })],
  first_approver: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择一级审批人', 'integer', 'blur', true), { min: 1 })],
  second_approver: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择二级审批人', 'integer', 'blur', true), { min: 1 })],
  third_approver: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择三级审批人', 'integer', 'blur', true), { min: 1 })],
  fourth_approver: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择四级审批人', 'integer', 'blur', true), { min: 1 })],
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('账户名称不能为空', 'string', 'blur', true))],
  bank_account: [{ required: true, message: '银行账号不能为空', trigger: 'blur' }],
  bank: [{ required: true, message: '开户银行支行不能为空', trigger: 'blur' }],
  bank_headquarters: [{ required: true, message: '开户银行总行不能为空', trigger: 'blur' }]
};

/***/ }),

/***/ 5700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{staticClass:"user-bank-form-dialog",attrs:{"visible":_vm.visible,"fullscreen":false,"before-close":_vm.closeDialog},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('template',{slot:"title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"medium","rules":_vm.formRules,"label-width":"120px"}},[_c('el-form-item',{key:"user_id",attrs:{"label":"用户名","prop":"user_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"disabled":_vm.id > 0,"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入用户名搜索","query-request":function (_){ return _vm.getPlatformUsersList(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1})); },"find-request":_vm.getCurrentUsersDetail},on:{"change":_vm.chooseUser},model:{value:(_vm.form.user_id),callback:function ($$v) {_vm.$set(_vm.form, "user_id", $$v)},expression:"form.user_id"}})],1),_vm._v(" "),_c('el-form-item',{key:"department_id",attrs:{"label":"部门","prop":"department_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请选择部门","query-request":_vm.getFinCenterDepartmentList,"find-request":_vm.getFinCenterDepartmentDetail},on:{"change":function($event){_vm.form.department_job_id = null}},model:{value:(_vm.form.department_id),callback:function ($$v) {_vm.$set(_vm.form, "department_id", $$v)},expression:"form.department_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"岗位","prop":"department_job_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请选择岗位","disabled":!_vm.form.department_id,"query-params":{department_id: _vm.form.department_id},"query-request":_vm.getDepartmentJobLists,"find-request":_vm.getDepartmentJobDetail},model:{value:(_vm.form.department_job_id),callback:function ($$v) {_vm.$set(_vm.form, "department_job_id", $$v)},expression:"form.department_job_id"}})],1),_vm._v(" "),_c('el-form-item',{key:"realname",attrs:{"label":"员工姓名","prop":"realname"}},[_c('el-input',{attrs:{"placeholder":"请输入员工姓名"},model:{value:(_vm.form.realname),callback:function ($$v) {_vm.$set(_vm.form, "realname", $$v)},expression:"form.realname"}})],1),_vm._v(" "),_c('el-form-item',{key:"first_approver",attrs:{"label":"一级审批人","prop":"first_approver"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入一级审批人名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.form.first_approver),callback:function ($$v) {_vm.$set(_vm.form, "first_approver", $$v)},expression:"form.first_approver"}})],1),_vm._v(" "),_c('el-form-item',{key:"second_approver",attrs:{"label":"二级审批人","prop":"second_approver"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入二级审批人名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.form.second_approver),callback:function ($$v) {_vm.$set(_vm.form, "second_approver", $$v)},expression:"form.second_approver"}})],1),_vm._v(" "),_c('el-form-item',{key:"third_approver",attrs:{"label":"三级审批人","prop":"third_approver"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入三级审批人名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.form.third_approver),callback:function ($$v) {_vm.$set(_vm.form, "third_approver", $$v)},expression:"form.third_approver"}})],1),_vm._v(" "),_c('el-form-item',{key:"fourth_approver",attrs:{"label":"四级审批人","prop":"fourth_approver"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入四级审批人名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.form.fourth_approver),callback:function ($$v) {_vm.$set(_vm.form, "fourth_approver", $$v)},expression:"form.fourth_approver"}})],1),_vm._v(" "),_c('el-form-item',{key:"name",attrs:{"label":"账户名称","prop":"name"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.id > 0,"clearable":"","placeholder":"请输入账户名称"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{key:"bank_account",attrs:{"label":"银行账号","prop":"bank_account"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.id > 0,"clearable":"","placeholder":"请输入银行账号"},model:{value:(_vm.form.bank_account),callback:function ($$v) {_vm.$set(_vm.form, "bank_account", $$v)},expression:"form.bank_account"}})],1),_vm._v(" "),_c('el-form-item',{key:"bank",attrs:{"label":"开户银行支行","prop":"bank"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.id > 0,"clearable":"","placeholder":"请输入开户银行支行"},model:{value:(_vm.form.bank),callback:function ($$v) {_vm.$set(_vm.form, "bank", $$v)},expression:"form.bank"}})],1),_vm._v(" "),_c('el-form-item',{key:"bank_headquarters",attrs:{"label":"开户银行总行","prop":"bank_headquarters"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.id > 0,"clearable":"","placeholder":"请输入开户银行总行"},model:{value:(_vm.form.bank_headquarters),callback:function ($$v) {_vm.$set(_vm.form, "bank_headquarters", $$v)},expression:"form.bank_headquarters"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"0 auto","text-align":"right"}},[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("保存\n        ")])],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{path: '/'}}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("财务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{key:"user_id",attrs:{"label":"用户名称","prop":"user_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入用户名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.user_id),callback:function ($$v) {_vm.$set(_vm.search, "user_id", $$v)},expression:"search.user_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"账户名称","prop":"name"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"请输入账户名称搜索"},model:{value:(_vm.search.name),callback:function ($$v) {_vm.$set(_vm.search, "name", $$v)},expression:"search.name"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.createUserBank}},[_vm._v("添加员工账户\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.batchCreateUserBank}},[_vm._v("批量添加\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.batchEditUserBank}},[_vm._v("批量修改\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.onExportSearch()}}},[_vm._v("按搜索结果导出\n      ")])],1),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{key:"id",attrs:{"prop":"id","label":"ID"}}),_vm._v(" "),_c('el-table-column',{key:"user_name",attrs:{"prop":"user_name","label":"用户名"}}),_vm._v(" "),_c('el-table-column',{key:"department_name",attrs:{"prop":"department_name","label":"部门"}}),_vm._v(" "),_c('el-table-column',{key:"department_job_name",attrs:{"prop":"department_job_name","label":"岗位"}}),_vm._v(" "),_c('el-table-column',{key:"realname",attrs:{"prop":"realname","label":"员工姓名"}}),_vm._v(" "),_c('el-table-column',{key:"first_approver_name",attrs:{"prop":"first_approver_name","label":"一级审批人"}}),_vm._v(" "),_c('el-table-column',{key:"second_approver_name",attrs:{"prop":"second_approver_name","label":"二级审批人"}}),_vm._v(" "),_c('el-table-column',{key:"third_approver_name",attrs:{"prop":"third_approver_name","label":"三级审批人"}}),_vm._v(" "),_c('el-table-column',{key:"fourth_approver_name",attrs:{"prop":"fourth_approver_name","label":"四级审批人"}}),_vm._v(" "),_c('el-table-column',{key:"name",attrs:{"prop":"name","label":"账户名称"}}),_vm._v(" "),_c('el-table-column',{key:"bank_account",attrs:{"prop":"bank_account","label":"银行账号"}}),_vm._v(" "),_c('el-table-column',{key:"bank",attrs:{"prop":"bank","label":"开户银行支行"}}),_vm._v(" "),_c('el-table-column',{key:"bank_headquarters",attrs:{"prop":"bank_headquarters","label":"开户银行总行"}}),_vm._v(" "),_c('el-table-column',{key:"operation",attrs:{"fixed":"right","label":"操作","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.editUserBank(scope.row.id)}}},[_vm._v("修改\n          ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onDelete(scope.row.id)}}},[_vm._v("删除\n          ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('user-bank-form-dialog',{attrs:{"visible":_vm.dialogVisible,"id":_vm.dialogId,"title":_vm.dialogTitle},on:{"closeDialog":_vm.closeDialog,"closeDialogRefresh":_vm.closeDialogRefresh}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/user-bank-account-table.0a05df11b410035a26b7.js